module.exports = __webpack_public_path__ + "static/media/barbell-plate-500.932c8524.png";